import { DataTable } from "primereact/datatable";
import BarGraph from "../../../../components/bar-chart";
import { Column } from "primereact/column";
import { CSVLink } from "react-csv";
import { numberFormatter } from "../../../../utils/formatter";

const ActualVsCommited = ({
  vendorData,
  vendorGraphData,
  selectedDistrict,
  commodity,
  appInsightsFunc,
}: any) => {
  const windowWidth = window.innerWidth;
  const fontSize = windowWidth < 1100 && windowWidth > 500 ? "8px" : "12px";
  const isCopper = commodity === "Copper Wire";
  const columns =
    vendorData && vendorData.length > 0 ? Object.keys(vendorData[0]) : [];
  const csvData =
    vendorData && vendorData.length > 0
      ? [
          // Headers
          ["", ...Object.keys(vendorData[0]).filter((key) => key !== "metric")],
          ...vendorData.map((item: { [x: string]: any }) => [
            ...Object.keys(item).map((key) => item[key]),
          ]),
        ]
      : [];

  const transformedVendorGraphData = vendorGraphData && [
    {
      actual: vendorGraphData?.reduce(
        (acc: any, obj: { actual: any }) => acc + obj.actual,
        0
      ),
      vendor: "TOTAL",
      committed: vendorGraphData?.reduce(
        (acc: any, obj: { committed: any }) => acc + obj.committed,
        0
      ),
    },
    ...vendorGraphData,
  ];

  return (
    <>
      <div className="flex justify-between w-full items-center">
        <label className="text-[1.3vw]">
          Committed vs Actual Volumes for{" "}
          <span className="text-[#86BC25] text-[1.3vw]">
            {selectedDistrict ? selectedDistrict : ""}
          </span>
        </label>
        {/* {vendorGraphData?.length > 0 && (
          <div className="text-white bold text-[0.8vw] bg-[#86BC25] p-[0.4vw] rounded-md  cursor-pointer flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1vw"
              height="1vw"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M14.6668 5.33464V9.20797C14.2602 8.97464 13.8135 8.81464 13.3335 8.72797V5.33464H2.66683V12.0013H8.72683C8.6935 12.2213 8.66683 12.4413 8.66683 12.668C8.66683 12.8946 8.6935 13.1146 8.72683 13.3346H2.66683C1.9335 13.3346 1.3335 12.7413 1.3335 12.0013V4.0013C1.3335 3.2613 1.92683 2.66797 2.66683 2.66797H6.66683L8.00016 4.0013H13.3335C14.0668 4.0013 14.6668 4.59464 14.6668 5.33464ZM13.3335 10.668H12.0002V13.3346H10.6668L12.6668 15.3346L14.6668 13.3346H13.3335V10.668Z"
                fill="white"
              />
            </svg>
            <span className="ml-[3px]">
              <CSVLink
                className="no-hover"
                filename={`Committed Vs Actual for ${selectedDistrict}`}
                style={{ textDecoration: "none" }}
                data={csvData}
                onClick={() =>
                  appInsightsFunc(
                    "Actual VS Commited",
                    `Commited Vs Actual for ${selectedDistrict}`
                  )
                }
              >
                Download
              </CSVLink>
            </span>
          </div>
        )} */}
      </div>
      <div className="w-full">
        {vendorGraphData?.length > 0 && (
          <div className="w-full h-[30vh] mb-[20px]">
            <BarGraph
              data={transformedVendorGraphData ?? []}
              XAxisLabel="vendor"
              dataKey1={"committed"}
              dataKey2={"actual"}
            />
          </div>
        )}
        {vendorGraphData?.length > 0 && (
          <div>
            {" "}
            <DataTable value={vendorData ?? []} scrollable>
              {columns.map((col, index) => (
                <Column
                  key={index}
                  body={(rowdata) => {
                    let data = rowdata[col];
                    if (isCopper && col === "metric" && typeof data === "string") {
                      data = data.replace(/TLs?/g, "Lbs");
                    }
                    return <span>{data ? data : "-"}</span>;
                  }}
                  style={
                    col === "metric"
                      ? {
                          fontWeight: "bold",
                          // Add any additional styles specific to the 'metric' column here
                        }
                      : {}
                  }
                  field={col}
                  header={col === "metric" ? "" : col.toUpperCase()}
                />
              ))}
            </DataTable>
          </div>
        )}
        {vendorGraphData?.length === 0 && (
          <div className="flex items-center justify-center h-full">
            No Data for the selected district
          </div>
        )}
      </div>
    </>
  );
};

export default ActualVsCommited;
